module.exports = __webpack_public_path__ + "img/IMG_7003.e5191b26.webp";